import styled from 'styled-components';

export const Container = styled.div`
  padding: 50px;
`;

export const TitleDescrip = styled.p`
  margin-top: -25px;
  margin-bottom: 50px;
`;
